import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import IconifyPicker from '@zunicornshift/mui-iconify-picker';


export interface ICategoryFormValues {
  category: string;
  description: string;
  icon?: string | null;
  parent_id: string | null;
}

interface CategoryFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: ICategoryFormValues) => void;
  initialValues?: ICategoryFormValues;
  title: string;
  availableParents: { id: string; name: string; level: number }[];
}

const CategoryForm: React.FC<CategoryFormProps> = ({
  open,
  onClose,
  onSubmit,
  initialValues,
  title,
  availableParents
}) => {
  const validationSchema = Yup.object({
    category: Yup.string().required('O nome da categoria é obrigatório.'),
    description: Yup.string().required('A descrição é obrigatória.'),
  });

  const formik = useFormik({
    initialValues: initialValues || { category: '', description: '', icon: null, parent_id: null },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
    enableReinitialize: true,
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Box mt={1}>
            <TextField
              fullWidth
              id="category"
              name="category"
              label="Nome da Categoria"
              value={formik.values.category}
              onChange={formik.handleChange}
              error={formik.touched.category && Boolean(formik.errors.category)}
              helperText={formik.touched.category && formik.errors.category}
            />
          </Box>
          <Box mt={3}>
            <FormControl fullWidth>
              <InputLabel id="parent-category-select-label">Categoria Pai</InputLabel>
              <Select
                labelId="parent-category-select-label"
                id="parent_id"
                name="parent_id"
                value={formik.values.parent_id || ''}
                onChange={formik.handleChange}
                label="Categoria Pai"
              >
                <MenuItem value="">
                  <em>Nenhuma (Categoria Principal)</em>
                </MenuItem>
                {availableParents.map((parent) => (
                  <MenuItem key={parent.id} value={parent.id}>
                    <Box sx={{ pl: parent.level * 2 }}>
                      {parent.name}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box mt={3} onClick={(e) => e.preventDefault()}>
            <IconifyPicker
              value={formik.values.icon}
              onChange={(icon) => formik.setFieldValue('icon', icon)}
              placeholderText="Selecione um ícone (opcional)"
            />
          </Box>
          <Box mt={3}>
            <TextField
              fullWidth
              id="description"
              name="description"
              label="Descrição"
              multiline
              rows={4}
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
          <Button color="primary" variant="contained" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CategoryForm;
